import { SearchIcon } from "@heroicons/react/solid"
import Button from "components/button"
import Input from "components/input"
import Select from "components/select"
import moment from "moment";
import { useState } from "react";
import Datepicker from "react-tailwindcss-datepicker"; 
import { twMerge } from "tailwind-merge";
import { STATUS_OPTIONS } from "utills/constants";

export const Filter = ({ currentFilterValues, setFilters}: {currentFilterValues: any, setFilters: any}) => {

  const _handleSubmitFilter = () => {
    setFilters([
      {field: "q", operator: "contains", value: keyword},
      {field: "is_active", operator: "eq", value: isActive},
      {field: "gte", operator: "eq", value: createdDate.startDate ? moment(createdDate.startDate).format('YYYY-MM-DD') : ""},
      {field: "lte", operator: "eq", value: createdDate.endDate ? moment(createdDate.endDate).format('YYYY-MM-DD') : ""},
      {field: "offset", operator: "eq", value: 0}
    ])
  }

  const [keyword, setKeyword] = useState(currentFilterValues.q);
  const [isActive, setIsActive] = useState<string>(currentFilterValues.is_active);
  const [createdDate, setCreatedDate] = useState({
    startDate: currentFilterValues.gte || "", 
    endDate: currentFilterValues.lte || ""
  });
  
  return (
    <div className="w-full flex flex-col gap-y-4 md:flex-row md:items-end md:gap-x-3">
      <div className="flex-1">
        <label htmlFor="role" className="block text-sm font-medium leading-6">
          Search
        </label>
        <div className="mt-2">
          <Input 
            className="px-2 py-2"
            label='Search by Role name'
            id='role'
            type="text"
            placeholder="Search by Full name, username"
            value={keyword}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setKeyword(e.target.value)}
            onKeyDown={(e: React.KeyboardEvent) => {
              if (e.key === 'Enter') {
                _handleSubmitFilter();
              }
            }}
          />
        </div>
      </div>
      <div className="flex-1">
        <label htmlFor="created_date" className="block text-sm font-medium leading-6">
          Created Date
        </label>
        <div className="mt-2">
          <Datepicker 
            value={createdDate}
            onChange={(value) => setCreatedDate({
              startDate: value?.startDate ? moment(value?.startDate).format('YYYY-MM-DD') : "",
              endDate: value?.endDate ? moment(value?.endDate).format('YYYY-MM-DD'): ""
            })}
            displayFormat="DD/MM/YYYY"
            placeholder="Start date - End date"
            inputClassName="date-picker"
            popoverDirection="down"
            containerClassName={(className) => twMerge(className, "date-picker-container")}
          /> 
        </div>
      </div>
      <div className="flex-1">
        <label htmlFor="status" className="block text-sm font-medium leading-6">
          Status
        </label>
        <div className="mt-2">
          <Select 
            options={STATUS_OPTIONS} 
            isClearable={true}
            id="status"
            placeholder="Select Status"
            className="py-0.5"
            value={STATUS_OPTIONS.find((d) => d.value === isActive)}
            onChange={(selected: {label: string; value: "true" | "false"}) => setIsActive(selected?.value)}
          />
        </div>
      </div>
      
      <div className="shrink-0">
        <label htmlFor="status" className="block text-sm font-medium leading-6">
          <span className="sr-only">Search</span>
        </label>
        <div className="mt-2 w-full">
          <Button type="submit" className="w-full px-4 py-2 border-y-[1px] border-solid border-brand-500 rounded-md" onClick={_handleSubmitFilter}>
            <SearchIcon className="w-3 h-4 text-white mr-2" /> Search
          </Button>
        </div>
      </div>
    </div>
  )
}